import styled, { css } from "styled-components";

import { COLORS } from "@treelab/panda";

const EmptyMessage = css`
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey};
  text-align: center;
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  user-select: none;
`;

export const PieCountError = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 248px;
  word-break: break-all;
  overflow-wrap: break-word;
  white-space: normal;
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey};
  text-align: center;

  & > span {
    word-break: normal;
  }
`;

export const EmptyAxis = styled.div<{ isExpand: boolean }>`
  position: absolute;
  top: ${({ isExpand }) => (isExpand ? "88px" : "48px")};
  bottom: ${({ isExpand }) => (isExpand ? "80px" : "44px")};
  left: ${({ isExpand }) => (isExpand ? "80px" : "36px")};
  right: ${({ isExpand }) => (isExpand ? "32px" : "24px")};
  border-left: 1px solid ${COLORS.greyLight2};
  border-bottom: 1px solid ${COLORS.greyLight2};
`;

export const ZoneContainer = styled.div`
  position: absolute;
  left: -12px;
  bottom: -12px;
  font-size: 12px;
  line-height: 12px;
  color: ${COLORS.greyLight1};
`;

export const AxisMessage = styled.div<{ isExpand: boolean }>`
  position: absolute;
  max-width: 70%;
  bottom: ${({ isExpand }) => (isExpand ? "92px" : "56px")};
  ${EmptyMessage};
`;

export const EmptyPie = styled.div<{ isExpand: boolean }>`
  position: absolute;
  top: ${({ isExpand }) => (isExpand ? "20px" : "8px")};
  bottom: ${({ isExpand }) => (isExpand ? "80px" : "60px")};
  left: ${({ isExpand }) => (isExpand ? "32px" : "24px")};
  right: ${({ isExpand }) => (isExpand ? "32px" : "24px")};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PieMessage = styled.div`
  position: absolute;
  left: center;
  bottom: -36px;
  ${EmptyMessage};
`;

export const Pie = styled.div<{ diameter: number; color: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ color }) => color};
  width: ${({ diameter }) => `${diameter}px`};
  height: ${({ diameter }) => `${diameter}px`};
  border-radius: 50%;
`;
